import React from 'react'
import moment from 'moment'
import numeral from 'numeral'
import { last, isEmpty, isNil } from 'lodash'
import {
 Upload, Modal, Select, Collapse, Table,
} from 'antd'
import {
 Button, Div, P,
} from 'konsys-ui'
import COMPANY_NAME, { ENUM } from '../../constants/company-name'
import { readExcelFile } from '../../utils/util-services'
import { theme } from '../../styles/_variables'

const columns = [
  {
    title: 'ชื่อ',
    dataIndex: 'costName',
    key: 'costName',
    width: '45%',
  },
  {
    title: 'วันที่',
    dataIndex: 'date',
    key: 'date',
    width: '15%',
  },
  {
    title: 'จำนวน',
    dataIndex: 'amount',
    key: 'amount',
    width: '15%',
    align: 'right',
  },
  {
    title: 'บริษัท',
    dataIndex: 'companyType',
    key: 'companyType',
    width: '25%',
  },
]

export const ImportModal = ({
 attr, modalAttr, handleImport,
}) => (
  <Modal
    destroyOnClose={true}
    visible={modalAttr.modalVisible}
    onCancel={() => {
      attr.setCompany(ENUM.PADOONGRICH)
      attr.setFile([])
      modalAttr.setModalVisible(false)
    }} width={1024}
    onOk={() => handleImport.doImport(true)}
    okButtonProps={{ disabled: isEmpty(attr.file) }}
    okText='นำเข้า'
    confirmLoading={handleImport.loading}
  >
    <Div width='100%' display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
      <Div width='50%' display='flex' flexDirection='column'>
        <Select
          style={{ margin: '16px 0' }}
          defaultValue={ENUM.PADOONGRICH}
          onChange={e => attr.setCompany(e)}
        >
          <Select.Option value={ENUM.PADOONGRICH}>{COMPANY_NAME.PADOONGRICH}</Select.Option>
          <Select.Option value={ENUM.TRANSPORT}>{COMPANY_NAME.TRANSPORT}</Select.Option>
        </Select>
        <Upload
          customRequest={() => null}
          processData={false}
          fileList={attr.file}
          accept={'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
          onChange={(e) => {
            attr.setFile(last(e.fileList) ? [last(e.fileList)] : [])
            if (last(e.fileList)) {
              readExcelFile(last(e.fileList).originFileObj, (convertedFile) => {
                attr.setArr(convertedFile)
                handleImport.doImport(false, convertedFile)
              })
            }
          }}
          beforeUpload={() => false}
          multiple={false}
        >
          <Button loading={handleImport.loading} inverse small text='อัพโหลดไฟล์' icon='far fa-file-upload' />
        </Upload>
      </Div>
      <Collapse activeKey={handleImport?.data ? '1' : undefined} style={{ width: '100%' }} bordered={false}>
        <Collapse.Panel header="สรุปข้อมูล" key="1" disabled={!handleImport?.data}>
          {
          handleImport?.data
            && <Div width='100%' display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
              {
                !isNil(handleImport?.data?.ImportFixedCostExcel?.data)
                ? handleImport?.data?.ImportFixedCostExcel?.data.map(type => (
                  <Div key={type.costType} width='100%'>
                    <P bold margin='32px 0 16px 0'>{type.costType}: {numeral(type.totalAmount).format('0,0.00')} บาท</P>
                    <Table
                      pagination={false}
                      size='small'
                      style={{ width: '100%' }}
                      dataSource={
                        type?.list.map(value => (
                          {
                            ...value,
                            date: moment(value.date).format('YYYY-MM-DD'),
                            amount: numeral(value.amount).format('0,0.00'),
                            companyType: COMPANY_NAME[value.companyType],
                          }
                        ))
                      }
                      columns={columns}
                    />
                  </Div>
                ))
                : <P bold color={theme.color.coolGrey}>Empty Data</P>
              }
            </Div>
          }
        </Collapse.Panel>
      </Collapse>
    </Div>
  </Modal>
)

export default ImportModal
